import React, { useEffect } from "react";
import { TextInput, Button, SaveButton, required, SimpleForm, useNotify, useRedirect, Toolbar, TopToolbar } from "react-admin";
import { Card, CardContent, Box } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PersonIcon from "@mui/icons-material/Person";
import authProvider from "../authProvider";

const ChangePassword = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  useEffect(() => {
    if(authProvider){
      authProvider
      .checkAuth()
      .then(() => {})
      .catch(() => {
        redirect("/login")
      });
    }
  }, [authProvider]);
 

  const handlePasswordChange = async (data) => {
    const { currentPassword, newPassword, confirmPassword } = data;

    if (newPassword !== confirmPassword) {
      notify("新しいパスワードと確認用パスワードが一致しません。", { type: "error" });
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/users/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify({ currentPassword, newPassword }),
      });

      if (!response.ok) {
        throw new Error("パスワード変更に失敗しました");
      }

      const result = await response.json();
      if (result.isError) {
        notify(result.message || "パスワード変更に失敗しました", { type: "error" });
      } else {
        notify("パスワードの変更が完了しました", { type: "success" });
        redirect("/my-profile");
      }
    } catch (err) {
      notify("エラーが発生しました。", { type: "error" });
    }
  };

  const CustomTopToolbar = () => (
    <Box>
        <TopToolbar>
          <Button
            label="マイページ"
            onClick={() => redirect("/my-profile")}
            startIcon={<PersonIcon />}
          />
        </TopToolbar>
    </Box>
  );


  const CustomToolbar = () => (
    <Toolbar>
        <Box>
          <SaveButton label="パスワードを変更" icon={<LockOpenIcon />} />
      </Box>
    </Toolbar>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent sx={{padding:0, marginBottom:-3}}>
        <SimpleForm
          onKeyDown={e => {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
          }}
            onSubmit={handlePasswordChange} toolbar={<CustomToolbar/>}
          >
            <TextInput
              label="現在のパスワード"
              type="password"
              source="currentPassword"
              fullWidth
              validate={required()}
            />
            <TextInput
              label="新しいパスワード"
              type="password"
              source="newPassword"
              fullWidth
              validate={required()}
            />
            <TextInput
              label="新しいパスワード（確認）"
              type="password"
              source="confirmPassword"
              fullWidth
              validate={required()}
            />
            
          </SimpleForm>
        </CardContent>
      </Card>
    </>
  );
};

export default ChangePassword;
